import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes } from 'react-router-dom';
import { SearchView } from './search.view';
export const SearchRoutes = () => (_jsxs(Routes, { children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: "conversations", replace: true }) }), _jsx(Route, { path: ":tab", element: _jsx(SearchView, {}) })] }));
